/*!
 * Copyright © 2005-2023 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Alfresco Example Content Application
 *
 * This file is part of the Alfresco Example Content Application.
 * If the software was purchased under a paid Alfresco license, the terms of
 * the paid license agreement will prevail. Otherwise, the software is
 * provided under the following open source license terms:
 *
 * The Alfresco Example Content Application is free software: you can redistribute it and/or modify
 * it under the terms of the GNU Lesser General Public License as published by
 * the Free Software Foundation, either version 3 of the License, or
 * (at your option) any later version.
 *
 * The Alfresco Example Content Application is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE. See the
 * GNU Lesser General Public License for more details.
 *
 * You should have received a copy of the GNU Lesser General Public License
 * from Hyland Software. If not, see <http://www.gnu.org/licenses/>.
 */

import { HttpHeaders } from '@angular/common/http';
import { AuthenticationService } from '@alfresco/adf-core';

/**
 * En-tete `Authorization` pour nos appels REST directs a Alfresco.
 *
 * Point d'entree UNIQUE : ce calcul etait auparavant duplique a l'identique sur 44 sites
 * (`isOauth() ? 'Bearer ' + getToken() : getTicketEcmBase64()`). ADF 6.7.1 a supprime
 * `getTicketEcmBase64()`, ce qui a casse les 44 d'un coup. En centralisant ici, une prochaine
 * rupture d'API ADF ne touchera plus qu'un seul fichier.
 *
 * On delegue a `AuthenticationService.getAuthHeaders()`, qui gere lui-meme les deux modes
 * (OIDC et Basic) et reste maintenu par ADF — plutot que de reimplementer la logique.
 *
 * @param auth service d'authentification ADF
 * @param requestUrl URL appelee ; ADF s'en sert notamment pour Kerberos
 */
export function algAuthorizationHeader(auth: AuthenticationService, requestUrl: string = window.location.origin): string {
  return auth.getAuthHeaders(requestUrl, new HttpHeaders()).get('Authorization') ?? '';
}
